<template>
  <with-actions>
    <div class="d-flex flex-column ml-auto" slot="context-actions">
      <div class="btn btn-outline-success" @click="create(false, $event)">
        {{ 'create' | t }}: {{ 'admin_right' | t }}
      </div>
      <div class="btn mt-3 btn-outline-success" @click="create(true, $event)">
        {{ 'create' | t }}: {{ 'local_user_template' | t }}
      </div>
    </div>
    <div class="card">
      <strong class="mx-2 my-3">{{ 'admin_right' | t }}</strong>
      <table class="table">
        <thead>
          <tr>
            <th>{{ 'name' | t }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="group in globalUserGroups">
            <td>
              <router-link :to="{ name: 'user_group', params: { user_group_id: group.id } }">{{
                group.name
              }}</router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card mt-5">
      <strong class="mx-2 my-3">{{ 'local_user_template' | t }}</strong>
      <table class="table">
        <thead>
          <tr>
            <th>{{ 'name' | t }}</th>
            <th>{{ 'locked' | t }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="group in localUserGroups">
            <td>
              <router-link :to="{ name: 'user_group', params: { user_group_id: group.id } }">{{
                group.name
              }}</router-link>
            </td>
            <td><i class="fa fa-check" v-if="group.locked_user_template"></i></td>
          </tr>
        </tbody>
      </table>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import $ from 'jquery';

export default {
  data: function () {
    return {
      user_groups: []
    };
  },
  async mounted() {
    this.setBreadcrumbs([{ to: { name: 'user_groups' }, text: 'User groups' }]);

    ({ data: this.user_groups } = await Api.findAll('user_groups'));
  },
  methods: {
    async create(visible, event) {
      if (event.target) {
        $(event.target).loading();
      }
      let group;
      ({ data: group } = await Api.create('user_groups', {
        scopes: '',
        name: 'New group',
        visible: visible
      }));

      this.$router.push({
        name: 'user_group',
        params: { user_group_id: group.id }
      });
      if (event.target) {
        $(event.target).loading(false);
      }
    }
  },
  computed: {
    localUserGroups() {
      return this.user_groups.filter((user_group) => user_group.visible === true);
    },
    globalUserGroups() {
      return this.user_groups.filter((user_group) => user_group.visible !== true);
    }
  }
};
</script>
